import { FunctionComponent, useContext } from "react";
import { DataContext } from '../../context/DataContext'

type BewohnerZusatzstoffe_Props = {
  bewohnerid: Number
}

export const BewohnerZusatzstoffe: FunctionComponent<BewohnerZusatzstoffe_Props> = ( { bewohnerid } ) => {

  const { appBewohnerZusatzstoffe , appZusatzstoffe } = useContext( DataContext ) ;

  return(
    <>
      {
        appBewohnerZusatzstoffe.length > 0
          ?
            <span style = { { color: 'red' } }>kein/e {
              appZusatzstoffe
                .filter(
                  ( entry:any ) => appBewohnerZusatzstoffe.includes( entry.zusatzstoff_id )
                )
                .map(
                  ( entry:any ) => entry.zusatzstoffe_anzeige + ') ' + entry.zusatzstoff_bezeichnung
                )
                .sort()
                .join( ', ' )
            }</span>
          :
            ''
      }
    </>
  )
}
